import React, { useEffect, useState } from "react";
import {
  Box,
  HStack,
  VStack,
  Heading,
  Text,
  Image,
  Button,
  Flex,
  SimpleGrid,
} from "@chakra-ui/react";
import { motion, animate } from "framer-motion";
import heroImage from "./Images/Hero-image.svg";
import arrow from "./Images/Button-Arrow.svg";
import standeEIcon from "./Images/Stande-e-icon.png";

const MotionBox = motion(Box);

// Define metrics with optional duration
const metrics = [
  { label: "Students Passing Rate", value: 100, suffix: "%", duration: 10 },
  { label: "Grade Skip", value: 1, suffix: " In 2", duration: 1 },
  { label: "A's & A* Achievement", value: 500, suffix: "+", duration: 10 },
  { label: "Years of Experience", value: 13, suffix: "+", duration: 10 },
];

function CountUp({ end, suffix, duration = 10 }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const controls = animate(0, end, {
      duration,
      onUpdate(v) {
        setCount(Math.floor(v));
      },
    });
    return () => controls.stop();
  }, [end, duration]);

  return (
    <Heading color="#0069CA" fontSize="24px" fontWeight="400">
      {count}
      {suffix}
    </Heading>
  );
}

export default function Home() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  return (
    <MotionBox
      id="home"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      p={0}
    >
      <Box>
        <Flex
          direction={{ base: "column-reverse", lg: "row" }}
          w="100%"
          mx="auto"
          align="center"
          justify="center"
          gap={{ base: 10, lg: 28 }}
          mt="74px"
          px={{ base: 4, md: 12 }}
        >
          <VStack
            spacing={{ base: 4, md: 6 }}
            align={{ base: "flex-start", lg: "flex-start" }}
            textAlign="left"
            maxW={{ base: "100%", lg: "40%" }}
          >
            <Flex align="center" gap={2} flexWrap="wrap">
              <Heading
                color="#161616"
                fontSize={{ base: "24px", md: "42px" }}
                fontWeight="550"
                lineHeight="1.2"
              >
                Cambridge IGCSE Courses with AI Solutions on Himmats' New Advanced Platform Stande Classroom
              </Heading>
              <Image
                src={standeEIcon}
                alt="stande-e-icon"
                boxSize={{ base: "20px", md: "24px" }}
                mt={{ base: "4px", md: "6px" }}
              />
            </Flex>

            <Text
              color="#343634"
              fontSize={{ base: "13px", md: "18px" }}
              fontWeight="400"
            >
              We've enhanced our teaching with cutting‑edge software that integrates powerful AI tools into our courses. This advancement allows us to deliver smarter, more interactive learning experiences, giving our students access to advanced features that enrich their education like never before for{' '}
              <Text as="span" fontWeight="700" color="#4BFF5C">
                FREE!
              </Text>
            </Text>

            <Button
              as="a"
              href="https://stande.co/login"
              target="_blank"
              rel="noopener noreferrer"
              borderRadius="24px"
              border="2.5px solid #E8E8E8"
              px={6}
              py={3}
              variant="outline"
            >
              <Flex align="center" gap={2}>
                <Text fontSize="14px" fontWeight="400">
                  Get Started For Free
                </Text>
                <Image src={arrow} alt="arrow" boxSize="20px" />
              </Flex>
            </Button>
          </VStack>

          <Image
            src={heroImage}
            alt="hero"
            maxW={{ base: "100%", lg: "50%" }}
            w="100%"
            objectFit="contain"
          />
        </Flex>
      </Box>

      <SimpleGrid
        columns={[1, 2, 4]}
        spacing={{ base: 6, md: 28 }}
        w="100%"
        px={{ base: 4, md: 8 }}
        mt={8}
      >
        {metrics.map((m) => (
          <VStack key={m.label} spacing={2}>
            <Flex
              w="88px"
              h="88px"
              align="center"
              justify="center"
              borderRadius="full"
              bg="#EBF2F7"
              whiteSpace="nowrap"
            >
              <CountUp end={m.value} suffix={m.suffix} duration={m.duration} />
            </Flex>
            <Text
              color="#161616"
              fontSize="18px"
              fontWeight="300"
              textAlign="center"
            >
              {m.label}
            </Text>
          </VStack>
        ))}
      </SimpleGrid>
    </MotionBox>
  );
}
